if (!customElements.get('h2o-product-accordion')) {
  class H2OProductAccordion extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('[data-accordion-panel]');
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.onSummaryClick = this.onSummaryClick.bind(this);
    }

    connectedCallback() {
      if (!this.details || !this.summary || !this.panel) return;

      this.summary.addEventListener('click', this.onSummaryClick);
      this.updateExpandedState();

      if (this.dataset.singleOpen === 'true' && this.details.open) {
        const openSibling = this.getSiblings().find((item) => item !== this && item.details?.open);
        if (openSibling) this.details.open = false;
      }
    }

    disconnectedCallback() {
      this.summary?.removeEventListener('click', this.onSummaryClick);
      this.animation?.cancel();
    }

    onSummaryClick(event) {
      event.preventDefault();

      if (this.isClosing || !this.details.open) {
        this.open();
      } else if (this.isExpanding || this.details.open) {
        this.close();
      }
    }

    getSiblings() {
      return Array.from(
        this.closest('.product__info-container')?.querySelectorAll('h2o-product-accordion') || []
      );
    }

    open() {
      if (this.dataset.singleOpen === 'true') {
        this.getSiblings().forEach((item) => {
          if (item !== this && item.details?.open) item.close();
        });
      }

      this.details.style.height = `${this.details.offsetHeight}px`;
      this.details.open = true;
      this.updateExpandedState();
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      this.animation?.cancel();
      this.isClosing = false;
      this.isExpanding = true;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight + this.panel.offsetHeight}px`;
      const duration = this.getDuration();

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      this.animation.onfinish = () => this.finish(true);
      this.animation.oncancel = () => {
        this.isExpanding = false;
      };
    }

    close() {
      this.animation?.cancel();
      this.isClosing = true;
      this.isExpanding = false;

      const startHeight = `${this.details.offsetHeight}px`;
      const endHeight = `${this.summary.offsetHeight}px`;
      const duration = this.getDuration();

      this.animation = this.details.animate(
        { height: [startHeight, endHeight] },
        { duration, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );
      this.animation.onfinish = () => this.finish(false);
      this.animation.oncancel = () => {
        this.isClosing = false;
      };
    }

    finish(open) {
      this.details.open = open;
      this.details.style.height = '';
      this.animation = null;
      this.isClosing = false;
      this.isExpanding = false;
      this.updateExpandedState();
    }

    updateExpandedState() {
      this.summary.setAttribute('aria-expanded', this.details.open ? 'true' : 'false');
    }

    getDuration() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return 0;
      return Number.parseInt(this.dataset.duration, 10) || 240;
    }
  }

  customElements.define('h2o-product-accordion', H2OProductAccordion);
}
